import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { ApiEndPoint } from 'src/app/shared/constants/apis.constant'
import { map, Subject } from 'rxjs'
import { Service, ServiceTemplateModel, UpdateDataModel, UpdatePriceModel } from '../models/service-template.model'
import { AddTemplateModel } from '../models/add-template.model'

@Injectable({ providedIn: 'root' })
export class ServicesService {
	editListenerSubject: Subject<Service> = new Subject<Service>()
	constructor(private http: HttpClient) {}

	// getServicesList(branchId: number, targetAudience: number) {
	// 	return this.http.get(
	// 		`${ApiEndPoint.getServicesListApi}?branchId=${branchId}&targetAudience=${targetAudience}`
	// 	)
	// }

	getCategories(body:any){
		return this.http.post(
			`${ApiEndPoint.getCategoriesApi}`,body
		)
	}

	getServices(filterBody: any) {
		return this.http.post(
			`${ApiEndPoint.GetFilteredBranchServices}`,
			filterBody
		)
	}

	getServiceDetails(id: number) {
		return this.http.get(`${ApiEndPoint.getServiceDetailsApi}?id=${id}`)
	}

	getServiceTemplateData(
		branchId: string,
		countryId: string,
		targetAudience: number
	) {
		return this.http
			.get(
				`${ApiEndPoint.getServiceTemplateDataApi}?branchId=${branchId}&countryId=${countryId}&targetAudience=${targetAudience}`
			)
			.pipe(
				map((response: any) => {
					return response.result as ServiceTemplateModel[]
				})
			)
	}
	updateStatus(id: number, isActive: boolean) {
		return this.http.put(`${ApiEndPoint.UpdateStatusApi}`, { id, isActive })
	}
	addServiceFromTemplate(body: AddTemplateModel) {
		return this.http.post(`${ApiEndPoint.AddServiceFromTemplateApi}`, body)
	}

	updateData(body: UpdateDataModel) {
		return this.http.put(`${ApiEndPoint.UpdateData}`, body)
	}

	UpdatePrice(body: UpdatePriceModel) {
		return this.http.put(`${ApiEndPoint.UpdatePrice}`, body)
	}
	deleteServiceList(id: number) {
		return this.http.delete(`${ApiEndPoint.DeleteServiceApi}?id=${id}`)
	}
	deleteServiceDiscound(body: any) {
		return this.http.put(ApiEndPoint.DeleteServiceDiscoundApi, body)
	}

	deleteService() {
		return this.http.delete(ApiEndPoint.DeleteFlag)
	}

	UpdateServiceDiscound(body: any) {
		return this.http.put(ApiEndPoint.UpdateDiscount, body)
	}
	branchPriceRange(branchId: number) {
		return this.http.get(
			`${ApiEndPoint.BranchPriceRange}?branchId=${branchId} `
		)
	}
	branchCategories(branchId: number, targetAudience: number, SearchText?: any) {
		return this.http.get(
			`${ApiEndPoint.BranchCategories}?branchId=${branchId}&targetAudience=${targetAudience}&SearchText=${SearchText} `
		)
	}

}
